import { Lenker } from '@gsm/entities';
import { DynamicFormControlLayout, DynamicFormValueControlModel, DynamicFormValueControlModelConfig, serializable } from '@ng-dynamic-forms/core';
import { Modify } from '../../helpers/modify.helper';
import { CustomFileModel } from '../custom-file-upload/custom-file-upload.model';

export const TYPE_LENKER_AUSWAEHLEN = 'LENKER_AUSWAEHLEN';

export interface LenkerAuswaehlenModelConfig extends DynamicFormValueControlModelConfig<LenkerAuswaehlenViewModel> {
  lenkerList?: Lenker[];
}

export class LenkerAuswaehlenModel extends DynamicFormValueControlModel<LenkerAuswaehlenViewModel> {
  @serializable() readonly type: string = TYPE_LENKER_AUSWAEHLEN;
  @serializable() lenkerList: Lenker[];

  constructor(config: LenkerAuswaehlenModelConfig, layout?: DynamicFormControlLayout) {
    super(config, layout);

    this.lenkerList = config.lenkerList || [];
  }
}

export type LenkerAuswaehlenViewModel = Modify<Lenker,
  {
    vorhanden?: LenkerVorhandenType;
    checklistItemList?: { checklistItemFileList?: CustomFileModel[] }[];
  }>;

// can be used like an enum:
export type LenkerVorhandenType = 'V' | 'A' | 'N' | 'U' | 'K';
export const LenkerVorhanden = {
  Vorhanden:    'V',
  Anlegen:      'A',
  Nachgebracht: 'N',
  Unbekannt:    'U',
  Kein:         'K',

  fromString(vorhanden: string): LenkerVorhandenType {
    return /^[VANUK]$/.test(vorhanden) ? (vorhanden as LenkerVorhandenType) : null;
  }
} as const;
